export default "__VITE_ASSET__D7J5s224__"